import React from "react";
import  ReactDOM  from "react-dom";
import App from "./App";
import {BrowserRouter} from "react-router-dom";
import { SnackbarProvider } from "notistack";
import "./index.css"
ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <SnackbarProvider
                maxSnack={1}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                preventDuplicate
            >
                <  App/>
            </SnackbarProvider>
        </BrowserRouter>
    </React.StrictMode>
   
,document.getElementById('root'));